import AmexGDADirHeader from './AmexGDADirHeader';

export default AmexGDADirHeader;
